import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';

import { CLEAR_SEARCH_DATA } from '../actions/actionTypes'

import SelectLibrary from '../components/SelectLibrary'
import SelectMaterialType from '../components/SelectMaterialType'
import TitleHeader from '../assets/images/search/title-header.jpg'
import { addSearchHistory } from '../services/storageService'

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
        margin: 7,
        borderRadius: 0,
        minWidth: 240,     
    },
    image: {
        width: '100%',
        maxHeight: 120,
    },
    form: {
        padding: 10,
    },
    input: {
        marginBottom: 5,
        marginTop: 5,
        width: '100%',
    },
    select: {
        marginTop: 20,
        marginBottom: 5,
        width: '100%',
    },
    link: {
        textDecoration: "none"
    },
    buttons: {
        marginTop: 15,
    },
  }));

export default function Search(props) {
    const classes = useStyles()

    const dispatch = useDispatch()
    const searchState = useSelector(state => state.search)

    const [titleKey, setTitleKey] = React.useState('')
    const [authorKey, setAuthorKey] = React.useState('')
    const [subjectKey, setSubjectKey] = React.useState('')
    const [library, setLibrary] = React.useState(searchState.library)
    const [materialType, setMaterialType] = React.useState(searchState.materialType)
    const [openToast, setOpenToast] = React.useState(false)

    useEffect(() => {
        dispatch({ type: CLEAR_SEARCH_DATA })
        if(props.location.state)
            setOpenToast(!!props.location.state.error)
    }, [])

    const search = () => {
        addSearchHistory('sigaa', titleKey, authorKey, subjectKey)

        const params = {
            title: titleKey,
            author: authorKey,
            subject: subjectKey,
            lib: library || '',
            material: materialType || '',
        }

        props.history.push({
            pathname: '/search-result', 
            search: new URLSearchParams(params).toString()
        })
    }

    const disableSearchButton = () => {
        if (titleKey == "" && authorKey == "" && subjectKey == "")
            return true

        const titleInvalid = titleKey.length > 0 && titleKey.length < 3
        const authorInvalid = authorKey.length > 0 && authorKey.length < 3
        const subjectInvalid = subjectKey.length > 0 && subjectKey.length < 3
        
        return titleInvalid || authorInvalid || subjectInvalid
    }

    return (
        <Grid container justify="center">
            <Grid item xs sm={6} lg={3}>
                <Paper className={classes.paper}>
                    <img className={classes.image} alt="Imagem de cabeçalho" src={TitleHeader} />
                    
                    <form className={classes.form} onSubmit={() => search()}>
                        <Typography variant="h5">Busca no SIGAA</Typography>

                        <TextField
                            id="title"
                            required={false}
                            label="Título"
                            className={classes.input}
                            value={titleKey}
                            margin="normal"
                            onChange={e => setTitleKey(e.target.value)}
                        />

                        <TextField
                            id="author"
                            required={false}
                            label="Autor"
                            className={classes.input}
                            value={authorKey}
                            margin="normal"
                            onChange={e => setAuthorKey(e.target.value)}
                        />

                        <TextField
                            id="subject"
                            required={false}
                            label="Assunto"
                            className={classes.input}
                            value={subjectKey}
                            margin="normal"
                            onChange={e => setSubjectKey(e.target.value)}
                        />

                        <SelectLibrary 
                            className={classes.select}
                            value={library}
                            onChange={e => setLibrary(e.target.value)}
                        />
                        
                        <SelectMaterialType 
                            className={classes.select}
                            value={materialType}
                            onChange={e => setMaterialType(e.target.value)}
                        />
                        
                        <Grid item container justify="space-between" className={classes.buttons}>
                            <Button 
                                color="primary" 
                                className={classes.link}
                                onClick={() => props.history.goBack()}
                            >
                                Voltar
                            </Button>
                            
                            <Button 
                                variant="contained" 
                                color="primary" 
                                type="submit"
                                disabled={disableSearchButton()}>
                                Buscar
                            </Button>
                        </Grid>
                    </form>
                </Paper>
            </Grid>
            <Snackbar
                open={openToast}
                autoHideDuration={5000}
                message={<span id="message-id">{
                    props.location.state ?
                    props.location.state.message :
                    ''}</span>
                }
                onClose={(event, reason) => setOpenToast(false)}
            />
        </Grid>
    );
}